"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BEMER_PARTNER_LEVELS = exports.MUX_API_VIDEO_ASSET_URL = exports.MUX_IMAGE_HOSTNAME = exports.MUX_STREAM_HOSTNAME = exports.CLOUDINARY_HOSTNAME = exports.XSTATE_INSPECT_URL = exports.TYPEKIT_URL = exports.SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_STAGE_DATASET = exports.FUNCTIONS_ENDPOINT_URL_PREFIX = exports.SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_READ_ONLY_TOKEN = exports.SANITY_STUDIO_API_PARTNER_LIBRARY_PRODUCTION_PROJECT_ID = exports.SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_PROJECT_ID = exports.SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_PROD_DATASET = exports.SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_DEV_DATASET = exports.SANITY_CDN_URL = exports.SANITY_API_VERSION = exports.MAP_BOX_SEARCH_API = exports.LEGAL_CMS_BASE_PATH_PREFIX = exports.GSTATIC_FONTS_URL = exports.GOOGLE_TAG_MANAGER_URL = exports.CURATOR_ENDPOINT = exports.CONSENTMANAGER_CDN_URL = exports.BEMER_EVENT_PORTAL_URL = exports.BEMER_ADDRESS_API_HOST_DEV = void 0;
// CMS
// ----------------------------------------------------------------------
var SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_PROJECT_ID = 'milq733q';
exports.SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_PROJECT_ID = SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_PROJECT_ID;
// generate key for SANITY_STUDIO_API_PARTNER_LIBRARY_PRODUCTION_PROJECT_ID
var SANITY_STUDIO_API_PARTNER_LIBRARY_PRODUCTION_PROJECT_ID = 'milq733q';
exports.SANITY_STUDIO_API_PARTNER_LIBRARY_PRODUCTION_PROJECT_ID = SANITY_STUDIO_API_PARTNER_LIBRARY_PRODUCTION_PROJECT_ID;
var SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_DEV_DATASET = 'playground';
exports.SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_DEV_DATASET = SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_DEV_DATASET;
var SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_STAGE_DATASET = 'stage';
exports.SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_STAGE_DATASET = SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_STAGE_DATASET;
var SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_PROD_DATASET = 'prod';
exports.SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_PROD_DATASET = SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_PROD_DATASET;
var SANITY_API_VERSION = '2021-04-23';
exports.SANITY_API_VERSION = SANITY_API_VERSION;
// functions
// ----------------------------------------------------------------------
var region;
if (!process.env.SANITY_STUDIO_API_REGION_CODE) {
    console.warn('SANITY_STUDIO_API_REGION_CODE is missing.');
    region = 'europe';
}
else {
    region = process.env.SANITY_STUDIO_API_REGION_CODE.toLocaleLowerCase();
}
var FUNCTIONS_BASE_PATH_PREFIX = process.env.NODE_ENV === 'development' ||
    process.env.SANITY_STUDIO_PACKAGE_NAME === 'partner-library'
    ? ''
    : "/cms-".concat(region);
var FUNCTIONS_ENDPOINT_URL_PREFIX = "".concat(FUNCTIONS_BASE_PATH_PREFIX, "/.netlify/functions/");
exports.FUNCTIONS_ENDPOINT_URL_PREFIX = FUNCTIONS_ENDPOINT_URL_PREFIX;
var LEGAL_CMS_BASE_PATH_PREFIX = process.env.NODE_ENV === 'development' ? '' : '/legal-cms';
exports.LEGAL_CMS_BASE_PATH_PREFIX = LEGAL_CMS_BASE_PATH_PREFIX;
// This is a read only token to the production project in Sanity.io.
// https://www.sanity.io/organizations/o85IzTuxf/project/milq733q
var SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_READ_ONLY_TOKEN = 'skE80vjXYBF3Ru44gpIxFuTiBSgZPGQx2cOyGxLWUxGh1Gp0P9QZSXICrAYDeS0FOZbamEvTdoCSV4dhbp8woqmoNdv0h3jJElLPgupHyESlfNvYAF89PYriCVLHQ6HTdNk5F96bQcILO5g4d8s3HY5DuRxYAO7p3KlK8UZgJIiDUd3Y8AOz';
exports.SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_READ_ONLY_TOKEN = SANITY_STUDIO_API_MARKETING_SITE_PRODUCTION_READ_ONLY_TOKEN;
// External services
var CONSENTMANAGER_CDN_URL = 'cdn.consentmanager.net';
exports.CONSENTMANAGER_CDN_URL = CONSENTMANAGER_CDN_URL;
var CURATOR_CDN_URL = 'cdn.curator.io';
var CURATOR_ENDPOINT = "https://".concat(CURATOR_CDN_URL, "/published/");
exports.CURATOR_ENDPOINT = CURATOR_ENDPOINT;
var GOOGLE_TAG_MANAGER_URL = 'https://www.googletagmanager.com';
exports.GOOGLE_TAG_MANAGER_URL = GOOGLE_TAG_MANAGER_URL;
var GSTATIC_FONTS_URL = 'https://fonts.gstatic.com';
exports.GSTATIC_FONTS_URL = GSTATIC_FONTS_URL;
var MAP_BOX_SEARCH_API = 'https://api.mapbox.com/geocoding/v5/mapbox.places';
exports.MAP_BOX_SEARCH_API = MAP_BOX_SEARCH_API;
var SANITY_CDN_URL = 'cdn.sanity.io';
exports.SANITY_CDN_URL = SANITY_CDN_URL;
var TYPEKIT_URL = 'https://use.typekit.net';
exports.TYPEKIT_URL = TYPEKIT_URL;
var XSTATE_INSPECT_URL = 'https://statecharts.io/inspect';
exports.XSTATE_INSPECT_URL = XSTATE_INSPECT_URL;
var CLOUDINARY_HOSTNAME = 'https://res.cloudinary.com';
exports.CLOUDINARY_HOSTNAME = CLOUDINARY_HOSTNAME;
var MUX_STREAM_HOSTNAME = 'https://stream.mux.com';
exports.MUX_STREAM_HOSTNAME = MUX_STREAM_HOSTNAME;
var MUX_IMAGE_HOSTNAME = 'https://image.mux.com';
exports.MUX_IMAGE_HOSTNAME = MUX_IMAGE_HOSTNAME;
var MUX_API_VIDEO_ASSET_URL = 'https://api.mux.com/video/v1/assets';
exports.MUX_API_VIDEO_ASSET_URL = MUX_API_VIDEO_ASSET_URL;
// Bemer hostnames
var BEMER_ADDRESS_API_HOST_DEV = 'https://dev.bemer.services/address';
exports.BEMER_ADDRESS_API_HOST_DEV = BEMER_ADDRESS_API_HOST_DEV;
// Bemer sites
var BEMER_EVENT_PORTAL_URL = 'https://events.bemergroup.com';
exports.BEMER_EVENT_PORTAL_URL = BEMER_EVENT_PORTAL_URL;
/**
 * Bemer Partner Level
 *
 * @see https://bergwerkio.atlassian.net/wiki/spaces/BEMER/pages/4054122543/bersicht+Bemer+Partnerlevel+Landesagenturen
 */
var BEMER_PARTNER_LEVELS = {
    IBDT: 35,
    BP: 40,
    BPPLUS: 50,
    GL: 60,
    TM: 70,
    TMPLUS: 80,
    OD: 90,
    ODPLUS: 99,
};
exports.BEMER_PARTNER_LEVELS = BEMER_PARTNER_LEVELS;
